/**
 * Public env surface for the web app.
 * Provider keys never belong here, only origins the browser is allowed to know.
 *
 *   REACT_APP_VANI_API     Vani Express agent (standalone HTML also reads VANI_API)
 * Production never reads a backend origin, the browser calls same-origin /api.
 */
import { SITE_ORIGIN, SITE_URL, absoluteUrl } from './site';

function stripSlash(value) {
  return String(value || '').replace(/\/$/, '');
}

export const BACKEND_URL =
  process.env.NODE_ENV === 'production'
    ? ''
    : stripSlash(process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000');

/** Vani agent origin. Distinct from BACKEND_URL until the APIs share a host. */
export const VANI_API = stripSlash(
  process.env.REACT_APP_VANI_API ||
    (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8787')
);

export { SITE_ORIGIN, SITE_URL, absoluteUrl };

/** So the vanilla island can keep reading window.VANI_API after config.js dies. */
export function publishPublicEnv() {
  if (typeof window === 'undefined') return;
  window.BACKEND_URL = BACKEND_URL;
  const insecureLocal =
    /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(VANI_API) &&
    window.location?.protocol === 'https:';
  window.VANI_API = insecureLocal ? '' : VANI_API;
}

publishPublicEnv();
